import { Select } from "@omnitok/ui";
import { useT } from "@/i18n";

const WIDTHS = [80, 100, 120, 160, 200, 240, 320];

/** Presentation-only control for the engine's existing max_width contract. */
export function ColumnWidthControl({ column, value, onChange }: {
  column: string;
  value?: number | null;
  onChange: (value: number | null) => void;
}): JSX.Element {
  const { t } = useT();
  const widths = value && !WIDTHS.includes(value) ? [value, ...WIDTHS] : WIDTHS;
  return (
    <div>
      <span className="block text-xs text-neutral-500">{t("inspector.table.maxWidth")}</span>
      <Select
        aria-label={`${t("inspector.table.maxWidth")}: ${column}`}
        value={value ? String(value) : ""}
        options={[
          { value: "", label: t("inspector.table.autoWidth") },
          ...widths.map((px) => ({ value: String(px), label: `${px} px` })),
        ]}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          onChange(e.target.value ? Number(e.target.value) : null)
        }
        size="sm"
        fullWidth
      />
      <p className="mt-1 text-xs text-neutral-500">{t("inspector.table.maxWidthHint")}</p>
    </div>
  );
}
